import { isNil } from '@utils/util';

/**
 * Formats a 10-digit string into the format "(XXX) XXX-XXXX".
 * @param {string} phoneNumber - a string containing exactly 10 numeric digits*
 *
 * @example
 * formatPhoneNumber("0000000000"); // returns "(000) 000-0000"
 * formatPhoneNumber("0000 00 00 00"); // returns "(000) 000-0000"
 * formatPhoneNumber("000-000-0000"); // returns "(000) 000-0000"
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  if (isNil(phoneNumber)) {
    return '';
  }

  const phoneNumberDigitsOnly = phoneNumber.replace(/\D/g, '');

  if (phoneNumberDigitsOnly.length !== 10) {
    return phoneNumber;
  }

  const areaCode = phoneNumberDigitsOnly.slice(0, 3);
  const prefix = phoneNumberDigitsOnly.slice(3, 6);
  const lineNumber = phoneNumberDigitsOnly.slice(6);

  return `(${areaCode}) ${prefix}-${lineNumber}`;
};
